import Html from './Html'
import PageWithSubpagesHtml from './PageWithSubpagesHtml'
import PracticeAreaDetailHtml from './PracticeAreaDetailHtml'

export default Html

export { PageWithSubpagesHtml, PracticeAreaDetailHtml }
